import { R } from './fancybox.esm-IDnR15x8.js';

if (!customElements.get('fancybox-element')) {
  class FancyboxElement extends HTMLElement {
    constructor() {
      super();
      this.fancybox();
    }

    /*
     * Create fancybox
     */
    fancybox() {
      R.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'fancybox__lightbox',
      });
    }
  }

  window.FancyboxElement = FancyboxElement;

  customElements.define('fancybox-element', FancyboxElement);
}
